<template>
	<div class="setter">
		<div class="setter__noti-wrapper">
			<p
				v-text="
					'※ 카테고리와 대표카테고리를 DRAG&DROP 로 설정할 수 있습니다.'
				"
				class="setter__noti"
			/>
			<p
				v-text="'※ 최대 5개까지만 대표카테고리로 설정이 가능합니다.'"
				class="setter__noti"
			/>
			<p
				v-text="'※ 대표카테고리만 순서설정이 반영됩니다.'"
				class="setter__noti"
			/>
		</div>
		<div class="setter__conts-wrapper">
			<div class="setter__arrow-icon-wrapper">
				<span class="setter__arrow-icon--right" />
				<span class="setter__arrow-icon--left" />
			</div>
			<div class="setter__conts-left">
				<p v-text="'카테고리'" class="setter__conts-title" />
				<div class="setter__conts-scroller">
					<table class="setter-table setter-table--cate">
						<thead>
							<tr>
								<th>카테고리명 / 메뉴타이틀</th>
								<th class="setter-table__cnt">캐스트수</th>
								<th class="setter-table__dp">전시여부</th>
								<th class="setter-table__no-conts" />
							</tr>
						</thead>
						<Draggable
							tag="tbody"
							group="list"
							:list="cateList"
							:class="[
								'setter-table__draggable',
								{
									'setter-table__draggable--empty':
										!cateList.length,
								},
							]"
						>
							<tr
								v-for="cate in cateList"
								:key="cate.idPouchCategory"
							>
								<td>
									<p>
										<strong v-text="'카테고리명: '" />
										{{ cate.pouchCategoryText }}
									</p>
									<p class="setter-table__text">
										<strong v-text="'메뉴타이틀: '" />
										{{ cate.mainTitle || '-' }}
									</p>
								</td>
								<td
									v-text="currency(String(cate.pouchCount))"
									class="setter-table__cnt"
								/>
								<td
									v-text="
										cate.isDisplay ? '전시중' : '비전시'
									"
									class="setter-table__dp"
								/>
								<td class="setter-table__no-conts" />
							</tr>
						</Draggable>
					</table>
				</div>
			</div>
			<div class="setter__conts-right">
				<p v-text="'대표카테고리'" class="setter__conts-title" />
				<div class="setter__conts-scroller">
					<table class="setter-table">
						<thead>
							<tr>
								<th>카테고리명 / 메뉴타이틀</th>
								<th class="setter-table__cnt">캐스트수</th>
								<th class="setter-table__dp">전시여부</th>
								<th class="setter-table__order">
									대표카테고리 순서
								</th>
							</tr>
						</thead>
						<Draggable
							tag="tbody"
							group="list"
							:list="mainList"
							:class="[
								'setter-table__draggable',
								{
									'setter-table__draggable--empty':
										!mainList.length,
								},
							]"
						>
							<tr
								v-for="(main, idx) in mainList"
								:key="main.idPouchCategory"
							>
								<td>
									<p>
										<strong v-text="'카테고리명: '" />
										{{ main.pouchCategoryText }}
									</p>
									<p class="setter-table__text">
										<strong v-text="'메뉴타이틀: '" />
										{{ main.mainTitle || '-' }}
									</p>
								</td>
								<td
									v-text="currency(String(main.pouchCount))"
									class="setter-table__cnt"
								/>
								<td
									v-text="
										main.isDisplay ? '전시중' : '비전시'
									"
									class="setter-table__dp"
								/>
								<td
									v-text="idx + 1"
									class="setter-table__order"
								/>
							</tr>
						</Draggable>
					</table>
				</div>
			</div>
			<button
				v-text="'적용'"
				@click="applyMainList"
				class="btn-main blue setter__apply-btn"
			/>
		</div>
	</div>
</template>
<script>
	import Draggable from 'vuedraggable';
	import util from '@/util';

	export default {
		name: 'MainCateSet',
		components: {
			Draggable,
		},
		data() {
			return {
				currency: util.currency,
				cateList: [],
				mainList: [],
			};
		},
		created() {
			this.setCate();
		},
		methods: {
			async setCate() {
				try {
					const {
						data: { pouchCategoryList },
					} = await this.$axiosNoah.get('/pouch/category', {
						params: {
							sort: 5,
							offset: 0,
							limit: 999,
						},
					});

					const [mainList, cateList] = pouchCategoryList.reduce(
						(acc, cur) => {
							const idx = cur.isMainCategory ? 0 : 1;
							acc[idx].push(cur);
							return acc;
						},
						[[], []]
					);

					this.cateList = cateList;
					this.mainList = mainList.sort(
						(a, b) => a.mainCategoryOrder - b.mainCategoryOrder
					);
				} catch (err) {
					console.error(err);
					alert('카테고리 목록을 불러오지 못했습니다.');
				}
			},
			async applyMainList() {
				const list = this.mainList;
				if (list.length > 5)
					return alert(
						'최대 5개까지만 대표카테고리로 설정이 가능합니다.'
					);
				await this.$axiosNoah.put('/pouch/category/mainCategoryOrder', {
					mainCategoryOrders: list.map(
						({ idPouchCategory }, idx) => ({
							idPouchCategory,
							mainCategoryOrder: idx + 1,
						})
					),
				});
				alert('대표카테고리 설정 완료.');
				this.$store.commit('toggleSpinner', true);
				this.$router.replace({
					query: { ...this.$route.query, reload: true },
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.setter {
		height: 100%;
		padding-top: 78px;
		padding-bottom: 20px;

		thead tr {
			background: #f4f7fa;
		}

		tr {
			background-color: white;
		}

		th,
		td {
			border: solid 1px #dfe6ee;
			padding: 4px;

			&:first-child {
				border-left: 0;
			}

			&:last-child {
				border-right: 0;
			}
		}

		th {
			border-top: 0;
			color: #657088;
			font-weight: bold;
		}

		&__noti-wrapper {
			margin-top: -66px;
		}

		&__noti {
			line-height: 22px;
			color: $btn-blue;
			font-size: 15px;
			font-weight: 700;
			white-space: pre-line;
		}

		&__conts-wrapper {
			position: relative;
			display: flex;
			width: 100%;
			height: 100%;
		}

		&__arrow-icon-wrapper {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			width: 24px;
			height: 48px;
		}

		&__arrow-icon--right,
		&__arrow-icon--left {
			display: block;
			width: 24px;
			height: 24px;
			background: no-repeat center/24px url('/static/img/icon/back.png');
			margin-left: 3px;
		}

		&__arrow-icon--right {
			transform: rotate(180deg);
			margin-left: -3px;
		}

		&__conts-left,
		&__conts-right {
			width: 50%;
			height: 100%;
			padding: 50px 14px 0 0;
		}

		&__conts-right {
			padding-right: 0;
			padding-left: 14px;
		}

		&__conts-title {
			margin-top: -50px;
			line-height: 36px;
			font-size: 15px;
			font-weight: 700;
		}

		&__conts-scroller {
			width: 100%;
			height: 100%;
			overflow-y: auto;
			border-radius: 4px;
			border: solid 1px #dfe6ee;
		}

		&-table {
			table-layout: fixed;

			&__draggable--empty:after {
				content: '';
				display: block;
				height: 200px;
			}

			&__no-conts {
				width: 0 !important;
				padding: 0 !important;
				border: 0 !important;
			}

			&__cnt,
			&__dp {
				width: 70px;
				text-align: center;
				padding: 4px 0;
				vertical-align: middle;
			}

			&__text {
				margin-top: 4px;
			}

			&__order {
				width: 110px;
				text-align: center;
				padding: 0;
				white-space: nowrap;
				font-weight: 700;
				vertical-align: middle;
			}
		}

		&-table--cate {
			th,
			td {
				&:nth-child(3) {
					border-right: 0;
				}
			}
		}

		&__apply-btn {
			position: absolute;
			margin: 0;
			right: 0;
			bottom: -42px;
		}
	}
</style>
